<template>
  <v-sheet class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
    <v-row v-if="!mobile" justify="space-around">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-form ref="form" @keyup.native.enter="saveDialog = true">
          <v-col cols="12" class="ml-n2">
            <header-medium :text="$t('Authenticate.personal_data')" />
          </v-col>
          <v-row justify="center">
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.first_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.first_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.first_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.last_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.last_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.last_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.email')" rules="required|email">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.email')"
                  prepend-inner-icon="mdi-pencil" v-model="user.email" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <vue-tel-input-vuetify v-model="user.phone" filled @input="checkPhone" defaultCountry="DE"
                :placeholder="$t('Headers.phone')" :label="$t('Headers.phone')" :error-messages="errorsPhone"
                mode="international" data-cy="contactPhone" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.birthdate')">
                <custom-date-picker v-model="user.birthdate" :error-messages="errors"  
                  :label="$t('Headers.birthdate')" :value="user.birthdate" />
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.password_certificate')" rules="required|password">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.password_certificate')"
                  prepend-inner-icon="mdi-pencil" v-model="user.password" required :error-messages="errors" type="password"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.confirm_password_certificate')" rules="required|password">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.confirm_password_certificate')"
                  prepend-inner-icon="mdi-pencil" v-model="user.confirm_password" required :error-messages="errors" type="password"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-col cols="12" class="ml-n2">
            <header-medium :text="$t('Authenticate.address_data')" />
          </v-col>
          <v-row justify="center">
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.street_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.street_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.street_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.house_number')" rules="required">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.house_number')"
                  prepend-inner-icon="mdi-pencil" v-model="user.house_number" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.zip_code')" rules="required">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.zip_code')"
                  prepend-inner-icon="mdi-pencil" v-model="user.zip_code" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.city_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.city_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.city_name" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.country')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.country')"
                  prepend-inner-icon="mdi-pencil" v-model="user.country" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
      
          <v-container class="ma-0 pa-0 mw-100">
            <v-row class="pt-5" dense>
              <v-col cols="12" sm="4" class="text-left">
                <custom-button :text="$t('Navigation.cancel_request')" color="red" @click="cancel()"></custom-button>
              </v-col>
              <v-col class="text-right">
                <custom-button :disabled="invalid" :text="$t('Authenticate.create_document')" @click="sendRequest"></custom-button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </validation-observer>
    </v-row>
    <v-container class="ma-0 pa-0 mw-100" v-if="mobile">
      <v-row justify="space-around">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-form ref="form" @keyup.native.enter="saveDialog = true">
          <v-col cols="12" class="ml-n2">
            <header-medium :text="$t('Authenticate.personal_data')" />
          </v-col>
          <v-row justify="center">
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.first_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.first_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.first_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.last_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.last_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.last_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.email')" rules="required|email">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.email')"
                  prepend-inner-icon="mdi-pencil" v-model="user.email" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <vue-tel-input-vuetify v-model="user.phone" filled @input="checkPhone" defaultCountry="DE"
                :placeholder="$t('Headers.phone')" :label="$t('Headers.phone')" :error-messages="errorsPhone"
                mode="international" data-cy="contactPhone" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.birthdate')">
                <custom-date-picker v-model="user.birthdate" :error-messages="errors"  
                  :label="$t('Headers.birthdate')" :value="user.birthdate" />
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.password_certificate')" rules="required|password">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.password_certificate')"
                  prepend-inner-icon="mdi-pencil" v-model="user.password" required :error-messages="errors" type="password"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.confirm_password_certificate')" rules="required|password">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.confirm_password_certificate')"
                  prepend-inner-icon="mdi-pencil" v-model="user.confirm_password" required :error-messages="errors" type="password"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-col cols="12" class="ml-n2">
            <header-medium :text="$t('Authenticate.address_data')" />
          </v-col>
          <v-row justify="center">
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.street_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.street_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.street_name" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.house_number')" rules="required">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.house_number')"
                  prepend-inner-icon="mdi-pencil" v-model="user.house_number" required
                  :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.zip_code')" rules="required">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.zip_code')"
                  prepend-inner-icon="mdi-pencil" v-model="user.zip_code" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.city_name')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.city_name')"
                  prepend-inner-icon="mdi-pencil" v-model="user.city_name" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3">
              <validation-provider v-slot="{ errors }" :name="$t('Headers.country')" rules="required|text">
                <v-text-field class="text-input" filled :rules="[rules.required]" :label="$t('Headers.country')"
                  prepend-inner-icon="mdi-pencil" v-model="user.country" required :error-messages="errors"></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
      
          <v-container class="ma-0 pa-0 mw-100">
            <v-row class="pt-5" dense>
              <v-col cols="12" sm="4" class="text-left">
                <custom-button :text="$t('Navigation.cancel_request')" color="red" @click="cancel()"></custom-button>
              </v-col>
              <v-col class="text-right">
                <custom-button :disabled="invalid" :text="$t('Authenticate.create_document')" @click="sendRequest"></custom-button>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </validation-observer>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script>
import CustomButton from "../../components/ui/input/CustomButton.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import AesAuthenticate from '../MainPage/AesAuthenticate.vue';
import i18n from "@/i18n";
import cookie from "vue-cookies";
import libphonenumbers from "libphonenumbers";
import ValidationDialog from "@/components/ui/other/ValidationDialog";
import CustomDatePicker from '../../components/ui/input/CustomDatePicker'
import {
  extend,
  ValidationProvider,
  setInteractionMode,
  ValidationObserver,
} from "vee-validate";
import { required, email, confirmed } from 'vee-validate/dist/rules'
import { log } from "@/helpers/logger";

setInteractionMode('eager')

extend('required', {
...required,
message: i18n.t('FormValidation.required'),
})

extend('email', {
...email,
message: i18n.t('FormValidation.email'),
})

extend('name_validate', {
validate: (value) =>
  /(^[a-zA-ZäÄöÖüÜßàÀèÈìÌòÒùÙçÇãÃñÑõÕëËïÏâÂêÊîÎôÔûÛáÁéÉíÍóÓúÚýÝ\-.\s]+)$/.test(
    value
  ),
message: i18n.t('FormValidation.name'),
})

extend('text', {
validate: (value) =>
  /(^[a-zA-Z0-9äÄöÖüÜßàÀèÈìÌòÒùÙçÇãÃñÑõÕëËïÏâÂêÊîÎôÔûÛáÁéÉíÍóÓúÚýÝ\-.\s]+)$/.test(
    value
  ),
message: i18n.t('FormValidation.field'),
})

extend('password', {
validate: (value) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^])[A-Za-z\d!@#$%^]{8,}$/.test(
    value
  ),
message: i18n.t('FormValidation.password'),
})

extend('confirmed', {
...confirmed,
message: i18n.t('FormValidation.password_match'),
})

export default {
  name: "qes-identify-exisiting",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    CustomDatePicker,
    AesAuthenticate,
    ValidationDialog,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t("Rules.required"),
      },
      mainColor: this.$vuetify.theme.themes.light.primary,
      mobile: false,
      user: {},
      errorsPhone: "",
      check: false,
      files: {},
    };
  },
  created: function () {
    this.$emit("step", 1);
    this.mobile = this.$vuetify.breakpoint.mdAndDown;
    this.workflow = this.currentWorkflow;
    this.signer_id = this.currentSignerId
    this.color = this.$vuetify.theme.themes.light.primary;
    this.$store.commit("set_loading", false);
    this.user = {
        first_name: this.workflow.first_name,
        last_name: this.workflow.last_name,
        email: this.workflow.email,
        phone: this.workflow.phone,
        street_name: "",
        house_number: "",
        zip_code: "",
        city_name: "",
        birthdate: "",
        password: "",
        confirm_password: "",
        country: "",
      }
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentSignerId() {
      return this.$store.state.auth.signer_id;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
  },
  methods: {
    cancel() {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/identify"
      );
      this.$store.commit("set_loading", true);
    },
    checkPhone(number, phone) {
      if (phone.isValid || number == '') {
        this.errorsPhone = "";
        this.user.phone = phone.number.e164;
        this.check = true;
        return true;
      } else {
        this.errorsPhone = i18n.t("FormValidation.phone");
        this.check = false;
        return false;
      }
    },
    sendRequest: async function(){   
      this.workflow.user = this.user
      await this.$store
      .dispatch("data/addExistingSignatureRequestData", this.workflow)
      .then(async (data) => {
          log(
          "QesIdentifyExisting.index.getFileToSign() - create File to Sign " +
              this.workflow.workflow_id,
          "info"
          );
          this.files = data;
          
        this.$router.push(
          "/qualifiedSignature/download/"+ this.currentWorkflow.signer_id
        );
      })
      .catch((err) => {
          log("QesIdentifyExisting.index.getFileToSign() - " + err, "error");
      });
    },
  },
};
</script>